// 網路介面（plan SPEC「設備資訊：區網位址與網路介面」）：shadow reported kinio_system.mac（主介面）與 kinio_system.netifs（介面清單）。
// 兩個都是 read_authz: owner——平台只回給有管理權的人（家戶 owner / admin、node_admin / 維運員），其他人的 shadow 根本沒有這兩個 key，
// 這裡不另判權限：有值就畫、沒有就不出現。

export type NetIfKind = 'wifi' | 'wired' | 'cellular';

export interface NetIf {
  name: string;
  kind: NetIfKind | '';
  mac: string;
  up: boolean;
  ip: string;
  ip6: string;
}

const str = (v: unknown) => (typeof v === 'string' ? v : '');

/** reported.kinio_system → 介面清單（依 name 排序；name 空或不是物件的略過）。沒有清單 → []。 */
export function netifsOf(sys: Record<string, unknown> | undefined): NetIf[] {
  const raw = sys?.netifs;
  if (!Array.isArray(raw)) return [];
  const out: NetIf[] = [];
  for (const x of raw) {
    if (!x || typeof x !== 'object') continue;
    const o = x as Record<string, unknown>;
    const name = str(o.name);
    if (!name) continue;
    const kind = str(o.kind);
    out.push({
      name,
      kind: kind === 'wifi' || kind === 'wired' || kind === 'cellular' ? kind : '',
      mac: str(o.mac),
      up: o.up === true,
      ip: str(o.ip),
      ip6: str(o.ip6),
    });
  }
  return out.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
}

/** 主介面 MAC（大寫冒號格式照設備報的原樣）；沒有 → ''。 */
export function primaryMacOf(sys: Record<string, unknown> | undefined): string {
  return str(sys?.mac);
}
